export const icons = [
  'el-icon-plus',
  'el-icon-delete',
  'el-icon-delete-solid',
  'el-icon-edit',
  'el-icon-edit-outline',
  'el-icon-view',

  'el-icon-menu',
  'el-icon-s-tools',
  'el-icon-user-solid',
  'el-icon-s-operation',
  'el-icon-s-home',
  'el-icon-s-custom',
  'el-icon-s-data',
  'el-icon-s-order',
  'el-icon-document',
  'el-icon-upload2',
  'el-icon-refresh',
  'el-icon-refresh-right',
  'el-icon-notebook-1',
  'el-icon-notebook-2',
  'el-icon-money',
  'el-icon-s-promotion',
  
  'home',
  'control',
  'statistics',
  'record',
  'device',
  'document',
  'listdot',
  'setting',
  'dot'
]

export const examOptions = {
  "1": {
    label: '提现',
    value: '1'
  },
  "2":{
    label: '发布',
    value: '2'
  },
  "3":{
    label: '添加站点',
    value: '3'
  },
  "4":{
    label: '修改站点',
    value: '4'
  },
}
